// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hF","input":"hG","button":"hH"};